import React, {useState} from "react";
import {makeStyles} from "@material-ui/core/styles";
import {useTranslation} from "react-i18next";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import {TabPanel} from "../TabPanel";

const useStyles = makeStyles((theme) => ({
    root: {
        margin: theme.spacing(2),
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
    },
    tabsPanel: {
        margin: theme.spacing(2)
    },
    selectedCount: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end'
    }
}));

export interface TabData {
    labelKey: string,
    key: string,
    preserveTab: boolean,
    isDisabled: boolean
    childComponent: (index: number, lastIndex: number, onChangeTab: (newTab: number) => void) => JSX.Element
}

interface Props {
    tabs: TabData[]
}

export const Wizard: React.FC<Props> = ({tabs}) => {
    const classes = useStyles()
    const {t} = useTranslation();

    const [currentTab, setCurrentTab] = useState(0);

    const handleTabChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        setCurrentTab(newValue);
    };

    return <div className={classes.root}>
        <Tabs value={currentTab} onChange={handleTabChange} aria-label="wizard tabs" indicatorColor="primary" variant="scrollable">
            {tabs.map((tab, index) => <Tab
                label={t(tab.labelKey)}
                {...buildTabId(tab.key)}
                disabled={tab.isDisabled}/>)}
        </Tabs>

        {tabs.map((tab, index) =>
            <TabPanel key={tab.key}
                      className={classes.tabsPanel}
                      value={currentTab}
                      index={index}
                      preserveTab={tab.preserveTab}>
                {tab.childComponent(index,
                    tabs.length - 1,
                    setCurrentTab)}
            </TabPanel>)}
    </div>
}

function buildTabId(key: string) {
    return {
        id: `tab-${key}`,
        'aria-controls': `tabpanel-${key}`,
    };
}
